export const categories = [
  { slug: 'dongzuo', name: '动作片', icon: 'ri-sword-line', count: 128 },
  { slug: 'xiju', name: '喜剧片', icon: 'ri-emotion-happy-line', count: 95 },
  { slug: 'aiqing', name: '爱情片', icon: 'ri-heart-line', count: 76 },
  { slug: 'kehuan', name: '科幻片', icon: 'ri-rocket-line', count: 82 },
  { slug: 'kongbu', name: '恐怖片', icon: 'ri-ghost-line', count: 64 },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-film-line', count: 43 },
  { slug: 'donghua', name: '动画片', icon: 'ri-emotion-laugh-line', count: 58 },
  { slug: 'fanzui', name: '犯罪片', icon: 'ri-police-car-line', count: 51 },
];

export const movies = [
  {
    id: 1,
    title: '流浪地球3',
    slug: 'liu-lang-di-qiu-3',
    category: '科幻片',
    categorySlug: 'kehuan',
    year: 2025,
    rating: 8.5,
    duration: '148分钟',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20sci-fi%20film%20The%20Wandering%20Earth%203%2C%20epic%20space%20background%20with%20stars%20and%20planets%2C%20astronaut%20silhouette%2C%20dramatic%20lighting%2C%20dark%20cinematic%20tone%2C%20Chinese%20title%20typography%2C%20film%20grain%20texture&width=600&height=800&seq=movie-poster-01&orientation=portrait',
    description: '太阳急速老化，持续膨胀。地球面临被吞没的危机。为了生存，人类提出一个名为"流浪地球"的大胆计划，倾全球之力在地球表面建造上万座发动机和转向发动机，推动地球离开太阳系，用2500年的时间奔往另外一个栖息之地。',
    isHot: true,
    isNew: true,
    tags: ['科幻', '灾难', '冒险'],
  },
  {
    id: 2,
    title: '封神第二部',
    slug: 'feng-shen-di-er-bu',
    category: '动作片',
    categorySlug: 'dongzuo',
    year: 2025,
    rating: 8.2,
    duration: '156分钟',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20fantasy%20epic%20Creation%20of%20the%20Gods%2C%20ancient%20Chinese%20mythology%20theme%2C%20warriors%20in%20ancient%20armor%2C%20dramatic%20battle%20scene%2C%20dark%20mystical%20atmosphere%2C%20gold%20and%20red%20color%20palette%2C%20film%20poster%20style&width=600&height=800&seq=movie-poster-02&orientation=portrait',
    description: '商王殷寿残暴无道，天下大乱。姜子牙携封神榜下山，寻找天下共主。姬发觉醒，率领西岐将士反抗暴政，一场惊天动地的封神大战拉开序幕。',
    isHot: true,
    isNew: false,
    tags: ['奇幻', '动作', '古装'],
  },
  {
    id: 3,
    title: '热辣滚烫',
    slug: 're-la-gun-tang',
    category: '喜剧片',
    categorySlug: 'xiju',
    year: 2024,
    rating: 7.8,
    duration: '129分钟',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20comedy%20drama%20YOLO%2C%20warm%20and%20inspiring%20theme%2C%20woman%20boxing%20silhouette%2C%20vibrant%20warm%20colors%2C%20motivational%20atmosphere%2C%20film%20poster%20design%20with%20Chinese%20typography&width=600&height=800&seq=movie-poster-03&orientation=portrait',
    description: '乐莹是一个善良的女孩，但生活却处处不如意。在一次偶然的机会下，她接触到了拳击运动，并决定改变自己。经过艰苦训练，她站上了拳击台，迎来了人生的高光时刻。',
    isHot: true,
    isNew: false,
    tags: ['喜剧', '运动', '励志'],
  },
  {
    id: 4,
    title: '消失的她',
    slug: 'xiao-shi-de-ta',
    category: '犯罪片',
    categorySlug: 'fanzui',
    year: 2023,
    rating: 7.5,
    duration: '121分钟',
    director: '陈思诚',
    actors: ['朱一龙', '倪妮', '文咏珊'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20mystery%20thriller%20Lost%20in%20the%20Stars%2C%20suspenseful%20mood%2C%20couple%20on%20tropical%20island%2C%20dark%20mysterious%20atmosphere%2C%20ocean%20background%2C%20thriller%20film%20poster%20style&width=600&height=800&seq=movie-poster-04&orientation=portrait',
    description: '何非的妻子李木子在海外旅行中突然失踪。当他报案后，一个陌生女人出现在他面前，声称自己就是他的妻子。何非陷入了巨大的疑惑和恐惧之中，真相到底是什么？',
    isHot: false,
    isNew: false,
    tags: ['悬疑', '犯罪', '剧情'],
  },
  {
    id: 5,
    title: '熊出没·逆转时空',
    slug: 'xiong-chu-mo-ni-zhuan-shi-kong',
    category: '动画片',
    categorySlug: 'donghua',
    year: 2024,
    rating: 8.0,
    duration: '98分钟',
    director: '丁亮',
    actors: ['张伟', '谭笑', '张秉君'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20animated%20film%20Boonie%20Bears%2C%20colorful%20adventure%20theme%2C%20two%20bears%20in%20futuristic%20setting%2C%20time%20travel%20elements%2C%20bright%20and%20playful%20colors%2C%20animated%20film%20poster%20style&width=600&height=800&seq=movie-poster-05&orientation=portrait',
    description: '光头强和熊大熊二意外穿越到了未来世界，他们发现未来的世界面临着巨大的危机。为了拯救未来，他们必须回到过去，修正历史中的关键事件。',
    isHot: false,
    isNew: true,
    tags: ['动画', '冒险', '喜剧'],
  },
  {
    id: 6,
    title: '孤注一掷',
    slug: 'gu-zhu-yi-zhi',
    category: '犯罪片',
    categorySlug: 'fanzui',
    year: 2023,
    rating: 7.3,
    duration: '130分钟',
    director: '申奥',
    actors: ['张艺兴', '金晨', '王传君'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20crime%20thriller%20No%20More%20Bets%2C%20dark%20intense%20theme%2C%20online%20scam%20operation%20setting%2C%20computer%20screens%20glowing%2C%20tense%20atmosphere%2C%20thriller%20film%20poster%20design&width=600&height=800&seq=movie-poster-06&orientation=portrait',
    description: '程序员潘生和模特安娜被高薪招聘所诱惑，来到了一家所谓的"海外高薪公司"，却发现自己陷入了一个巨大的诈骗工厂。他们必须想办法逃出生天。',
    isHot: false,
    isNew: false,
    tags: ['犯罪', '剧情', '悬疑'],
  },
  {
    id: 7,
    title: '长津湖之水门桥',
    slug: 'chang-jin-hu-shui-men-qiao',
    category: '动作片',
    categorySlug: 'dongzuo',
    year: 2022,
    rating: 8.3,
    duration: '149分钟',
    director: '陈凯歌',
    actors: ['吴京', '易烊千玺', '朱亚文'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20war%20film%20The%20Battle%20at%20Lake%20Changjin%2C%20epic%20war%20scene%20in%20snow%2C%20soldiers%20in%20winter%20camouflage%2C%20dramatic%20battle%20atmosphere%2C%20cold%20blue%20tone%2C%20war%20film%20poster%20style&width=600&height=800&seq=movie-poster-07&orientation=portrait',
    description: '在极寒严酷的环境下，中国人民志愿军东线作战部队凭着钢铁意志和英勇无畏的战斗精神，扭转了战场态势。水门桥一战，成为抗美援朝战争中的关键战役。',
    isHot: false,
    isNew: false,
    tags: ['战争', '历史', '动作'],
  },
  {
    id: 8,
    title: '你好，李焕英',
    slug: 'ni-hao-li-huan-ying',
    category: '喜剧片',
    categorySlug: 'xiju',
    year: 2021,
    rating: 8.1,
    duration: '128分钟',
    director: '贾玲',
    actors: ['贾玲', '张小斐', '沈腾'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20comedy%20drama%20Hi%20Mom%2C%20warm%20family%20theme%2C%20mother%20and%20daughter%20in%201980s%20China%2C%20nostalgic%20retro%20style%2C%20warm%20golden%20lighting%2C%20heartwarming%20film%20poster&width=600&height=800&seq=movie-poster-08&orientation=portrait',
    description: '贾晓玲穿越回到了1981年，遇到了年轻时的母亲李焕英。她决定用自己的方式让母亲过上更好的生活，却发现母亲早已知道了一切。',
    isHot: false,
    isNew: false,
    tags: ['喜剧', '亲情', '穿越'],
  },
  {
    id: 9,
    title: '深海',
    slug: 'shen-hai',
    category: '动画片',
    categorySlug: 'donghua',
    year: 2023,
    rating: 7.9,
    duration: '112分钟',
    director: '田晓鹏',
    actors: ['苏鑫', '王亭文'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20animated%20film%20Deep%20Sea%2C%20magical%20underwater%20world%2C%20vibrant%20colorful%20sea%20creatures%2C%20dreamlike%20atmosphere%2C%20girl%20diving%20in%20deep%20ocean%2C%20stunning%20visuals%2C%20animated%20film%20poster&width=600&height=800&seq=movie-poster-09&orientation=portrait',
    description: '一个叫参宿的少女，意外坠入了一个奇幻的深海世界，在这里她遇到了一个叫南河的少年。两人一起经历了一段独特而奇妙的生命旅程。',
    isHot: false,
    isNew: true,
    tags: ['动画', '奇幻', '冒险'],
  },
  {
    id: 10,
    title: '满江红',
    slug: 'man-jiang-hong',
    category: '动作片',
    categorySlug: 'dongzuo',
    year: 2023,
    rating: 7.6,
    duration: '159分钟',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20historical%20thriller%20Full%20River%20Red%2C%20Song%20dynasty%20setting%2C%20ancient%20Chinese%20courtyard%2C%20dramatic%20red%20and%20black%20color%20scheme%2C%20suspenseful%20mood%2C%20historical%20film%20poster%20design&width=600&height=800&seq=movie-poster-10&orientation=portrait',
    description: '南宋绍兴年间，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信不翼而飞。小兵张大与亲兵营副统领孙均被卷入了一场巨大的阴谋之中。',
    isHot: false,
    isNew: false,
    tags: ['古装', '悬疑', '喜剧'],
  },
  {
    id: 11,
    title: '八角笼中',
    slug: 'ba-jiao-long-zhong',
    category: '动作片',
    categorySlug: 'dongzuo',
    year: 2023,
    rating: 7.4,
    duration: '117分钟',
    director: '王宝强',
    actors: ['王宝强', '陈永胜', '史彭元'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20sports%20drama%20Octagonal%2C%20boxing%20ring%20setting%2C%20young%20fighters%20training%2C%20gritty%20realistic%20style%2C%20warm%20earthy%20tones%2C%20inspirational%20sports%20film%20poster&width=600&height=800&seq=movie-poster-11&orientation=portrait',
    description: '向腾辉倾注心血把一群大山里的孤儿培养成真正的格斗运动员。然而随着往日表演视频被爆出，这些"残忍、血腥"的画面刺激了不明真相的人们的神经。',
    isHot: false,
    isNew: false,
    tags: ['动作', '运动', '剧情'],
  },
  {
    id: 12,
    title: '人生大事',
    slug: 'ren-sheng-da-shi',
    category: '纪录片',
    categorySlug: 'jilupian',
    year: 2022,
    rating: 7.8,
    duration: '112分钟',
    director: '刘江江',
    actors: ['朱一龙', '杨恩又'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20drama%20Lighting%20Up%20the%20Stars%2C%20funeral%20home%20setting%2C%20man%20and%20little%20girl%20bonding%2C%20warm%20emotional%20tone%2C%20life%20and%20death%20theme%2C%20touching%20film%20poster%20design&width=600&height=800&seq=movie-poster-12&orientation=portrait',
    description: '殡葬师莫三妹遇到了孤儿武小文，小文的出现意外地改变了莫三妹对职业和生活的态度。两人从彼此对抗到相互治愈，共同面对人生的各种大事。',
    isHot: false,
    isNew: false,
    tags: ['剧情', '家庭', '治愈'],
  },
  {
    id: 13,
    title: '你的婚礼',
    slug: 'ni-de-hun-li',
    category: '爱情片',
    categorySlug: 'aiqing',
    year: 2021,
    rating: 7.0,
    duration: '115分钟',
    director: '韩天',
    actors: ['许光汉', '章若楠'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20romance%20film%20My%20Love%2C%20young%20couple%20in%20school%20uniforms%2C%20nostalgic%20romantic%20atmosphere%2C%20cherry%20blossoms%2C%20warm%20sunset%20lighting%2C%20romantic%20film%20poster&width=600&height=800&seq=movie-poster-13&orientation=portrait',
    description: '周潇齐和尤咏慈从高中到大学的爱情故事，十五年的时光里，他们彼此相爱却又不断错过。当终于再次相遇时，一切都已经不同了。',
    isHot: false,
    isNew: false,
    tags: ['爱情', '青春', '校园'],
  },
  {
    id: 14,
    title: '一闪一闪亮星星',
    slug: 'yi-shan-yi-shan-liang-xing-xing',
    category: '爱情片',
    categorySlug: 'aiqing',
    year: 2023,
    rating: 7.3,
    duration: '107分钟',
    director: '陈小明',
    actors: ['屈楚萧', '张佳宁'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20romance%20fantasy%20film%20Shining%20For%20One%20Thing%2C%20starry%20night%20sky%20background%2C%20young%20couple%20gazing%20at%20stars%2C%20dreamy%20romantic%20atmosphere%2C%20soft%20blue%20and%20purple%20tones%2C%20romantic%20film%20poster%20design&width=600&height=800&seq=movie-poster-14&orientation=portrait',
    description: '林北星为了救回因意外离世的恋人张万森，一次次穿越回过去。每一次穿越，她都在努力改写命运，却发现爱的力量远比想象中更强大。',
    isHot: false,
    isNew: true,
    tags: ['爱情', '奇幻', '穿越'],
  },
  {
    id: 15,
    title: '这么多年',
    slug: 'zhe-me-duo-nian',
    category: '爱情片',
    categorySlug: 'aiqing',
    year: 2023,
    rating: 7.1,
    duration: '118分钟',
    director: '季竹青',
    actors: ['张新成', '孙千'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20romance%20drama%20All%20These%20Years%2C%20young%20man%20and%20woman%20in%20urban%20setting%2C%20emotional%20embrace%2C%20warm%20golden%20hour%20lighting%2C%20modern%20romantic%20film%20poster%20style&width=600&height=800&seq=movie-poster-15&orientation=portrait',
    description: '陈见夏和李燃从高中时代相识，经历了十年的分分合合。多年后，当他们再次重逢，那些被时间冲刷过的情感依然鲜活如初。',
    isHot: false,
    isNew: false,
    tags: ['爱情', '成长', '剧情'],
  },
  {
    id: 16,
    title: '我爱你！',
    slug: 'wo-ai-ni',
    category: '爱情片',
    categorySlug: 'aiqing',
    year: 2023,
    rating: 8.0,
    duration: '116分钟',
    director: '韩延',
    actors: ['倪大红', '惠英红', '梁家辉', '叶童'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20romance%20drama%20Love%20Never%20Ends%2C%20elderly%20couple%20holding%20hands%20in%20park%2C%20autumn%20leaves%2C%20warm%20touching%20atmosphere%2C%20mature%20love%20theme%2C%20emotional%20film%20poster&width=600&height=800&seq=movie-poster-16&orientation=portrait',
    description: '四位老人——空巢老人常为戒和拾荒老太李慧如，以及年迈夫妇谢定山和赵欢欣，在生命晚年的时光里，他们用纯粹而浓烈的情感诠释了什么是真正的爱。',
    isHot: false,
    isNew: false,
    tags: ['爱情', '老年', '温情'],
  },
  {
    id: 17,
    title: '独行月球',
    slug: 'du-xing-yue-qiu',
    category: '科幻片',
    categorySlug: 'kehuan',
    year: 2022,
    rating: 7.6,
    duration: '122分钟',
    director: '张吃鱼',
    actors: ['沈腾', '马丽'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20sci-fi%20comedy%20Moon%20Man%2C%20lone%20astronaut%20on%20moon%20surface%2C%20Earth%20visible%20in%20background%2C%20humorous%20yet%20dramatic%2C%20space%20theme%2C%20golden%20yellow%20moon%20tones%2C%20film%20poster&width=600&height=800&seq=movie-poster-17&orientation=portrait',
    description: '人类为阻止小行星撞击地球，在月球部署了月盾计划。陨石提前来袭，全员紧急撤离时，维修工独孤月因为意外错过了撤离通知，一个人被留在了月球上。',
    isHot: true,
    isNew: false,
    tags: ['科幻', '喜剧', '太空'],
  },
  {
    id: 18,
    title: '明日战记',
    slug: 'ming-ri-zhan-ji',
    category: '科幻片',
    categorySlug: 'kehuan',
    year: 2022,
    rating: 6.9,
    duration: '99分钟',
    director: '吴炫辉',
    actors: ['古天乐', '刘青云', '刘嘉玲'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20sci-fi%20action%20Warriors%20of%20Future%2C%20futuristic%20mecha%20soldiers%2C%20post-apocalyptic%20city%2C%20high-tech%20armor%2C%20dark%20metallic%20tones%2C%20sci-fi%20action%20film%20poster&width=600&height=800&seq=movie-poster-18&orientation=portrait',
    description: '近未来，一颗陨石坠落地球，带来了杀伤力极强的外星生物潘朵拉。人类面临灭顶之灾，一支精英机甲战队临危受命，深入危险区域执行一场拯救人类的任务。',
    isHot: false,
    isNew: false,
    tags: ['科幻', '动作', '机甲'],
  },
  {
    id: 19,
    title: '外太空的莫扎特',
    slug: 'wai-tai-kong-de-mo-zha-te',
    category: '科幻片',
    categorySlug: 'kehuan',
    year: 2022,
    rating: 6.5,
    duration: '136分钟',
    director: '陈思诚',
    actors: ['黄渤', '荣梓杉'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20sci-fi%20family%20film%20Mozart%20from%20Space%2C%20cute%20alien%20panda-like%20creature%2C%20colorful%20magical%20atmosphere%2C%20family%20adventure%20theme%2C%20whimsical%20and%20playful%2C%20family%20film%20poster&width=600&height=800&seq=movie-poster-19&orientation=portrait',
    description: '任大望一心想把儿子任小天培养成钢琴演奏家，为此父子俩争吵不断。一天，一个神秘的外星人"莫扎特"出现在他们的生活中，一切都变得不一样了。',
    isHot: false,
    isNew: false,
    tags: ['科幻', '家庭', '喜剧'],
  },
  {
    id: 20,
    title: '回廊亭',
    slug: 'hui-lang-ting',
    category: '恐怖片',
    categorySlug: 'kongbu',
    year: 2023,
    rating: 6.2,
    duration: '104分钟',
    director: '来牧宽',
    actors: ['任素汐', '刘敏涛'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20mystery%20thriller%20Revival%2C%20dark%20mansion%20corridor%2C%20mysterious%20woman%20silhouette%2C%20suspenseful%20atmosphere%2C%20dim%20candlelight%2C%20gothic%20thriller%20film%20poster%20style&width=600&height=800&seq=movie-poster-20&orientation=portrait',
    description: '一位富商离世后，律师周扬带着遗嘱来到回廊亭宣读。在这个与世隔绝的古宅中，神秘事件接连发生，每个人似乎都藏着不可告人的秘密。',
    isHot: false,
    isNew: false,
    tags: ['恐怖', '悬疑', '推理'],
  },
  {
    id: 21,
    title: '山村老尸',
    slug: 'shan-cun-lao-shi',
    category: '恐怖片',
    categorySlug: 'kongbu',
    year: 1999,
    rating: 7.2,
    duration: '87分钟',
    director: '梁鸿华',
    actors: ['吴镇宇', '黎姿'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20classic%20Chinese%20horror%20film%20The%20Wicked%20Ghost%2C%20eerie%20rural%20village%20at%20night%2C%20ghostly%20figure%20in%20white%2C%20foggy%20atmosphere%2C%20dark%20green%20tones%2C%20vintage%20horror%20film%20poster&width=600&height=800&seq=movie-poster-21&orientation=portrait',
    description: '一群年轻人玩起了通灵游戏，没想到真的召唤出了一个怨念极深的女鬼。女鬼开始对他们展开可怕的报复，而这一切背后隐藏着一个令人心惊的悲惨故事。',
    isHot: false,
    isNew: false,
    tags: ['恐怖', '经典', '灵异'],
  },
  {
    id: 22,
    title: '中邪',
    slug: 'zhong-xie',
    category: '恐怖片',
    categorySlug: 'kongbu',
    year: 2016,
    rating: 7.4,
    duration: '110分钟',
    director: '马凯',
    actors: ['董天文', '何佳'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20found-footage%20horror%20film%20The%20Possessed%2C%20handheld%20camera%20style%2C%20dark%20rural%20house%2C%20terrifying%20atmosphere%2C%20raw%20realistic%20style%2C%20independent%20horror%20film%20poster&width=600&height=800&seq=movie-poster-22&orientation=portrait',
    description: '两名大学生前往农村拍摄一部关于算命的纪录片，他们跟随一位算命先生来到一个偏远的山村。在那里，他们遭遇了令人毛骨悚然的超自然事件。',
    isHot: false,
    isNew: false,
    tags: ['恐怖', '伪纪录片', '悬疑'],
  },
  {
    id: 23,
    title: '京城81号',
    slug: 'jing-cheng-81-hao',
    category: '恐怖片',
    categorySlug: 'kongbu',
    year: 2014,
    rating: 6.5,
    duration: '90分钟',
    director: '叶伟民',
    actors: ['吴镇宇', '林心如', '杨祐宁'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20horror%20film%20The%20House%20That%20Never%20Dies%2C%20ancient%20Beijing%20mansion%2C%20ghostly%20female%20figure%2C%20dark%20gothic%20atmosphere%2C%20red%20and%20black%20color%20palette%2C%20haunted%20house%20film%20poster&width=600&height=800&seq=movie-poster-23&orientation=portrait',
    description: '作家许若卿搬入了京城有名的凶宅——朝内81号。随着她的入住，这栋房子的可怕过往逐渐浮出水面，一段跨越百年的惊悚故事就此展开。',
    isHot: false,
    isNew: false,
    tags: ['恐怖', '古宅', '惊悚'],
  },
  {
    id: 24,
    title: '大地震',
    slug: 'da-di-zhen',
    category: '纪录片',
    categorySlug: 'jilupian',
    year: 2021,
    rating: 8.6,
    duration: '96分钟',
    director: '陈为军',
    actors: [],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20documentary%20film%20poster%20about%20earthquake%20disaster%2C%20rescue%20workers%20in%20action%2C%20dramatic%20real%20footage%20style%2C%20emotional%20rescue%20scenes%2C%20warm%20humanitarian%20tone%2C%20documentary%20poster%20design&width=600&height=800&seq=movie-poster-24&orientation=portrait',
    description: '本片记录了汶川地震发生后的真实救援场景，聚焦于普通人在灾难面前的勇气与坚韧。大量珍贵的历史影像资料，展现了中华民族在灾难中守望相助的伟大精神。',
    isHot: false,
    isNew: false,
    tags: ['纪录片', '灾难', '历史'],
  },
  {
    id: 25,
    title: '舌尖上的新年',
    slug: 'she-jian-shang-de-xin-nian',
    category: '纪录片',
    categorySlug: 'jilupian',
    year: 2016,
    rating: 7.9,
    duration: '89分钟',
    director: '陈磊',
    actors: [],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20documentary%20film%20poster%20about%20Chinese%20New%20Year%20food%20culture%2C%20traditional%20Chinese%20dishes%2C%20festive%20family%20dinner%2C%20warm%20red%20and%20gold%20colors%2C%20mouth-watering%20food%20photography%2C%20documentary%20poster&width=600&height=800&seq=movie-poster-25&orientation=portrait',
    description: '从中国南到北，从城市到乡村，本片记录了中国各地丰富多彩的年夜饭文化。每一道菜背后都承载着一个家庭的记忆和对新年的美好期盼。',
    isHot: false,
    isNew: false,
    tags: ['纪录片', '美食', '文化'],
  },
  {
    id: 26,
    title: '二十二',
    slug: 'er-shi-er',
    category: '纪录片',
    categorySlug: 'jilupian',
    year: 2017,
    rating: 8.8,
    duration: '99分钟',
    director: '郭柯',
    actors: [],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20documentary%20film%20poster%20about%20comfort%20women%20survivors%2C%20elderly%20Chinese%20women%20telling%20stories%2C%20emotional%20and%20powerful%2C%20black%20and%20white%20portrait%20style%2C%20historical%20documentary%20poster&width=600&height=800&seq=movie-poster-26&orientation=portrait',
    description: '2014年，中国内地仅剩22位"慰安妇"幸存者。本片记录了这些老人现在的生活状态和内心世界，她们用平静的外表掩盖了曾经经历的苦难，却依然选择了宽容与坚强。',
    isHot: false,
    isNew: false,
    tags: ['纪录片', '历史', '人文'],
  },
  {
    id: 27,
    title: '四个春天',
    slug: 'si-ge-chun-tian',
    category: '纪录片',
    categorySlug: 'jilupian',
    year: 2019,
    rating: 8.7,
    duration: '105分钟',
    director: '陆庆屹',
    actors: [],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20documentary%20film%20poster%20about%20family%20life%20in%20rural%20China%2C%20elderly%20couple%20in%20countryside%2C%20spring%20blossoms%2C%20warm%20natural%20lighting%2C%20intimate%20family%20documentary%20poster%20style&width=600&height=800&seq=movie-poster-27&orientation=portrait',
    description: '导演陆庆屹以自己年逾古稀的父母为主角，记录了四个春天里他们在贵州独山老家的日常生活。镜头下，这对老夫妻平淡而诗意的生活令人动容。',
    isHot: false,
    isNew: false,
    tags: ['纪录片', '家庭', '生活'],
  },
  {
    id: 28,
    title: '除暴',
    slug: 'chu-bao',
    category: '犯罪片',
    categorySlug: 'fanzui',
    year: 2020,
    rating: 7.1,
    duration: '95分钟',
    director: '刘浩良',
    actors: ['王千源', '吴彦祖'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20crime%20action%20film%20Caught%20in%20Time%2C%201990s%20police%20vs%20robbers%2C%20intense%20confrontation%2C%20gritty%20realistic%20style%2C%20dark%20urban%20atmosphere%2C%20crime%20thriller%20poster&width=600&height=800&seq=movie-poster-28&orientation=portrait',
    description: '上世纪90年代，刑警钟诚受命追捕一个屡屡犯下惊天劫案的悍匪团伙。双方展开了一场长达数年的生死较量，最终正义战胜了邪恶。',
    isHot: false,
    isNew: false,
    tags: ['犯罪', '动作', '警匪'],
  },
  {
    id: 29,
    title: '三大队',
    slug: 'san-da-dui',
    category: '犯罪片',
    categorySlug: 'fanzui',
    year: 2023,
    rating: 7.8,
    duration: '132分钟',
    director: '戴墨',
    actors: ['张译', '李晨', '魏晨'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20crime%20drama%20Endless%20Journey%2C%20police%20detectives%20in%20plain%20clothes%2C%20determined%20expressions%2C%20gritty%20realistic%20style%2C%20manhunt%20theme%2C%20crime%20drama%20poster&width=600&height=800&seq=movie-poster-29&orientation=portrait',
    description: '十二年前，三大队刑警在侦破一起恶性案件时意外导致嫌犯死亡，全队被判入狱。出狱后，他们以普通人身份继续追凶，坚持十二年终于将真正的凶手绳之以法。',
    isHot: false,
    isNew: true,
    tags: ['犯罪', '剧情', '真实事件'],
  },
  {
    id: 30,
    title: '年会不能停！',
    slug: 'nian-hui-bu-neng-ting',
    category: '喜剧片',
    categorySlug: 'xiju',
    year: 2023,
    rating: 8.2,
    duration: '117分钟',
    director: '董润年',
    actors: ['大鹏', '白客', '庄达菲'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20workplace%20comedy%20Johnny%20Keep%20Walking%2C%20office%20workers%20at%20company%20annual%20party%2C%20satirical%20humor%2C%20bright%20colorful%20office%20setting%2C%20comedic%20film%20poster%20style&width=600&height=800&seq=movie-poster-30&orientation=portrait',
    description: '钳工胡建林阴差阳错被调入集团总部。面对这个与他格格不入的职场世界，他凭借一身"手艺"在公司年会上掀起了一场令人啼笑皆非的风波。',
    isHot: true,
    isNew: false,
    tags: ['喜剧', '职场', '讽刺'],
  },
  {
    id: 31,
    title: '这个杀手不太冷静',
    slug: 'zhe-ge-sha-shou-bu-tai-leng-jing',
    category: '喜剧片',
    categorySlug: 'xiju',
    year: 2022,
    rating: 7.4,
    duration: '109分钟',
    director: '邢文雄',
    actors: ['马丽', '魏翔'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20for%20Chinese%20action%20comedy%20Too%20Cool%20To%20Kill%2C%20actor%20playing%20hitman%20role%2C%20comedy%20action%20style%2C%20film%20set%20background%2C%20warm%20humorous%20tone%2C%20comedy%20film%20poster%20design&width=600&height=800&seq=movie-poster-31&orientation=portrait',
    description: '龙套演员魏成功被女明星米兰选中，在一部电影中饰演杀手。然而他不知道的是，这一切并非演戏，而是一场真实的黑帮交易。',
    isHot: false,
    isNew: false,
    tags: ['喜剧', '动作', '黑色幽默'],
  },
  {
    id: 32,
    title: '长安三万里',
    slug: 'chang-an-san-wan-li',
    category: '动画片',
    categorySlug: 'donghua',
    year: 2023,
    rating: 8.3,
    duration: '168分钟',
    director: '谢君伟',
    actors: ['杨天翔', '凌振赫'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20animated%20film%20poster%20for%20Chinese%20historical%20animation%20Chang%20An%2C%20Tang%20dynasty%20ancient%20capital%2C%20poets%20in%20traditional%20robes%2C%20ink%20painting%20style%2C%20golden%20sunset%20atmosphere%2C%20epic%20animated%20film%20poster&width=600&height=800&seq=movie-poster-32&orientation=portrait',
    description: '安史之乱后，大唐由盛转衰。困守孤城的高适向监军回忆起自己与李白的一生往事。两位伟大诗人截然不同的人生轨迹，共同勾勒出盛唐的辉煌与落幕。',
    isHot: true,
    isNew: false,
    tags: ['动画', '历史', '文学'],
  },
  {
    id: 33,
    title: '白蛇：缘起',
    slug: 'bai-she-yuan-qi',
    category: '动画片',
    categorySlug: 'donghua',
    year: 2019,
    rating: 8.1,
    duration: '99分钟',
    director: '黄家康',
    actors: ['张喆', '杨天翔'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20animated%20film%20poster%20for%20Chinese%20fantasy%20animation%20White%20Snake%2C%20beautiful%20snake%20spirit%20in%20ancient%20China%2C%20magical%20atmosphere%2C%20ink%20painting%20aesthetics%2C%20romantic%20fantasy%2C%20animated%20film%20poster&width=600&height=800&seq=movie-poster-33&orientation=portrait',
    description: '晚唐年间，国师发动民众大量捕蛇。前去刺杀国师的白蛇意外失忆，被捕蛇村少年阿宣救下。为帮助少女找回记忆，两人踏上了一段冒险旅程，感情也在相处中逐渐升温。',
    isHot: false,
    isNew: false,
    tags: ['动画', '爱情', '奇幻'],
  },
];

export const faqs = [
  {
    question: '快看影视需要注册才能观看吗？',
    answer: '不需要。快看影视所有电影均可免费在线观看，无需注册、无需付费，打开网站即可畅享高清电影。',
  },
  {
    question: '为什么有些电影播放时会出现缓冲？',
    answer: '正常情况下快看影视的电影播放流畅不卡顿。如果出现缓冲，可能与您当前的网络环境有关，建议检查网络连接或切换清晰度尝试。',
  },
  {
    question: '快看影视的电影画质如何？',
    answer: '快看影视提供高清画质播放，大部分电影支持1080P超清画质。我们不断优化播放体验，确保您享受最佳的观影效果。',
  },
  {
    question: '快看影视有手机APP吗？',
    answer: '目前快看影视主要通过网页端提供服务，您可以直接在手机浏览器中访问我们的网站，同样可以获得流畅的观影体验。',
  },
  {
    question: '快看影视的电影更新速度快吗？',
    answer: '非常快！快看影视实时同步最新院线电影和热门影视资源，新电影上线后我们会在第一时间更新，让您不再错过任何好片。',
  },
  {
    question: '在快看影视看电影安全吗？',
    answer: '安全。快看影视是正规运营的影视平台，我们不收集用户个人信息，不会弹出恶意广告，为您的观影安全保驾护航。',
  },
];

export const testimonials = [
  {
    name: '电影爱好者小王',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20man%2C%20warm%20smile%2C%20casual%20style%2C%20clean%20white%20background%2C%20soft%20studio%20lighting&width=100&height=100&seq=avatar-01&orientation=squarish',
    rating: 5,
    comment: '快看影视真的是我看过最好用的免费电影网站！片源丰富，画质清晰，最重要的是真的不卡顿，强烈推荐给所有喜欢看电影的朋友！',
  },
  {
    name: '追剧达人小李',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20woman%2C%20friendly%20expression%2C%20modern%20style%2C%20clean%20white%20background%2C%20soft%20studio%20lighting&width=100&height=100&seq=avatar-02&orientation=squarish',
    rating: 5,
    comment: '更新速度超快！每次有新电影上线，快看影视都是第一时间就更新了。再也不用到处找资源了，一个网站就够了。',
  },
  {
    name: '影视博主老张',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20middle%20aged%20Chinese%20man%2C%20confident%20expression%2C%20business%20casual%2C%20clean%20white%20background%2C%20soft%20studio%20lighting&width=100&height=100&seq=avatar-03&orientation=squarish',
    rating: 5,
    comment: '作为一个影视博主，我对画质要求很高。快看影视的高清画质和流畅播放让我非常满意，已经成为我日常看电影的首选平台。',
  },
];